import { ProjectKpiMakerComponent } from './../components/library/project/project-kpi-maker.component';
import { LibraryProjectDetailsFlowchartComponent } from './../components/library/project/library-project-details-flowchart.component';
import { LibraryProjectDetailsEmbedComponent } from './../components/library/project/library-project-details-embed.component';
import { LibraryProjectDetailsMetadataComponent } from './../components/library/project/library-project-details-metadata.component';
import { LibraryProjectDetailsThumbnailComponent } from './../components/library/project/library-project-details-thumbnail.component';
import { LibraryProjectDetailsComponent } from './../components/library/project/library-project-details.component';
import { LibraryProjectListComponent } from './../components/library/project/library-project-list.component';
import { LibraryProjectDetailsAnalysisComponent } from '../components/library/project/library-project-details-analysis.component';
import { PlacementListComponent } from '../components/library/placement/placement-list.component';
import { PlacementDetailsComponent } from '../components/library/placement/placement-details.component';
import { PlacementDetailsMetadataComponent } from '../components/library/placement/placement-details-metadata.component';
import { LineupListComponent } from '../components/library/lineup/lineup-list.component';
import { LineupDetailsComponent } from '../components/library/lineup/lineup-details.component';
import { LineupDetailsCyclesComponent } from '../components/library/lineup/lineup-details-cycles.component';
import { LineupDetailsGeneralComponent } from '../components/library/lineup/lineup-details-general.component';
import { LineupDetailsConfigurationComponent } from '../components/library/lineup/lineup-details-configuration.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';

import { SharedModule } from './shared.module';
import { BbTableModule } from './bb-table.module';
import { PipesModule } from './pipes.module';

import { LibraryComponent } from '../components/library/library.component';
import { EmbedPreviewComponent } from '../components/library/embed-preview.component';
import { MediaclipListComponent } from '../components/library/mediaclip/mediaclip-list.component';
import { PlayoutListComponent } from '../components/library/playout/playout-list.component';
import { TrashListComponent } from '../components/library/trash/trash-list.component';
import { PlaylistListComponent } from '../components/library/playlist/playlist-list.component';
import { PlaylistDetailsComponent } from '../components/library/playlist/playlist-details.component';
import { PlaylistDetailsGeneralComponent } from '../components/library/playlist/playlist-details-general.component';
import { PlaylistDetailsRssComponent } from '../components/library/playlist/playlist-details-rss.component';
import { PlaylistDetailsEmbedComponent } from '../components/library/playlist/playlist-details-embed.component';
import { PlaylistSelectComponent } from '../components/library/mediaclip/playlist-select.component';
import { SocialListComponent } from '../components/library/social/social-list.component';
import { SocialDetailsComponent } from '../components/library/social/social-details.component';
import { SocialDetailsYoutubeComponent } from '../components/library/social/social-details-youtube.component';
import { SocialDetailsAutomatedSyncingComponent } from '../components/library/social/social-details-automated-syncing.component';
import { SocialDetailsFacebookComponent } from '../components/library/social/social-details-facebook.component';
import { SocialFacebookSyncedComponent } from '../components/library/social/social-facebook-synced.component';
import { SocialDetailsInstagramComponent } from '../components/library/social/social-details-instagram.component';
import { SocialChannelCardComponent } from '../components/library/social/social-channel-card.component';

import { BbLibraryMenuComponent } from '../components/library/bb-library-menu.component';

import { NavigateAwayGuard } from '../components/shared/abstract-details.component';
import { AuthGuard } from '../guards/auth.guard';
import { FlowchartService } from '../services/flowchart.service';
import { SubtitleService } from '../services/subtitle.service';
import { InteractivityTimelineDetailsComponent }
	from '../components/library/interactivity/interactivity-timeline-details.component';
import { PermissionGuard } from '../guards/permission.guard';

import { MediaclipDetailsComponent } from '../components/library/mediaclip/mediaclip-details.component';
import { MediaclipDetailsMetadataComponent } from '../components/library/mediaclip/mediaclip-details-metadata.component';
import { MediaclipDetailsChaptersComponent } from '../components/library/mediaclip/mediaclip-details-chapters.component';
import { MediaclipDetailsLanguagesComponent } from '../components/library/mediaclip/mediaclip-details-languages.component';
import { MediaclipDetailsLiveComponent } from '../components/library/mediaclip/mediaclip-details-live.component';
import { MediaclipDetailsRestreamingComponent } from '../components/library/mediaclip/mediaclip-details-restreaming.component';
import { MediaclipDetailsReactComponent } from '../components/library/mediaclip/mediaclip-details-react.component';
import { SubtitleQuickEditComponent } from '../components/library/mediaclip/subtitle-quickedit.component';
import { AudiotrackQuickEditComponent } from '../components/library/mediaclip/audiotrack-quickedit.component';
import { AssetQuickeditComponent } from '../components/library/mediaclip/asset-quickedit.component';
import { RestreamQuickeditComponent } from '../components/library/mediaclip/restream-quickedit.component';
import { MediaclipDetailsEmbedComponent } from '../components/library/mediaclip/mediaclip-details-embed.component';
import { UploadTranscodeBbLivestreamComponent } from '../components/library/upload-transcode/upload-transcode-bb-livestream.component';
import { MediaclipDetailsThumbnailComponent } from '../components/library/mediaclip/mediaclip-details-thumbnail.component';
import { MediaclipDetailsResourcesComponent } from '../components/library/mediaclip/mediaclip-details-resources.component';
import { MediaclipDetailsExportComponent } from '../components/library/mediaclip/mediaclip-details-export.component';

import { UploadTranscodeComponent } from '../components/library/upload-transcode/upload-transcode.component';
import { UploadTranscodeUploadComponent } from '../components/library/upload-transcode/upload-transcode-upload.component';

import { UploadTranscodePublicationImportComponent } from '../components/library/upload-transcode/upload-transcode-publication-import.component';
import { UploadTranscodeLiveComponent } from '../components/library/upload-transcode/upload-transcode-live.component';
import { UploadTranscodeThirdPartyLivestreamComponent } from '../components/library/upload-transcode/upload-transcode-thirdparty-livestream.component';

import { ChannelListComponent } from '../components/library/channel/channel-list.component';
import { ChannelDetailsComponent } from '../components/library/channel/channel-details.component';
import { ChannelDetailsGeneralComponent } from '../components/library/channel/channel-details-general.component';
import { ChannelDetailsDetailpageComponent } from '../components/library/channel/channel-details-detailpage.component';
import { ChannelDetailsElementsComponent } from '../components/library/channel/channel-details-elements.component';
import { ChannelDetailsEmbedComponent } from '../components/library/channel/channel-details-embed.component';

import { DatafeedListComponent } from '../components/library/datafeed/datafeed-list.component';
import { DatafeedDetailsComponent } from '../components/library/datafeed/datafeed-details.component';
import { DatafeedDetailsMetadataComponent } from '../components/library/datafeed/datafeed-details-metadata.component';

import { PlayoutDetailsComponent } from '../components/library/playout/playout-details.component';
import { PlayoutDetailsAppearanceComponent } from '../components/library/playout/playout-details-appearance.component';
import { PlayoutDetailsControlbarComponent } from '../components/library/playout/playout-details-controlbar.component';
import { PlayoutDetailsSharingComponent } from '../components/library/playout/playout-details-sharing.component';
import { PlayoutDetailsStartEndscreenComponent } from '../components/library/playout/playout-details-start-endscreen.component';
import { BbFitmodeComponent } from '../components/shared/bb-fitmode/bb-fitmode.component';
import { PlayoutDetailsBehaviourComponent } from '../components/library/playout/playout-details-behaviour.component';
import { PlayoutDetailsAdvertisingComponent } from '../components/library/playout/playout-details-advertising.component';
import { PlayoutDetailsMiscellaneousComponent } from '../components/library/playout/playout-details-miscellaneous.component';
import { PlayoutDetailsViewpageComponent } from '../components/library/playout/playout-details-viewpage.component';

import { TemplatesListComponent } from '../components/library/template/templates-list.component';
import { TemplateRedirectComponent } from '../components/library/template/template-redirect.component';
import { LibraryProjectDetailsReactComponent } from 'app/components/library/project/library-project-details-react.component';
import { LineupDetailsEmbedComponent } from 'app/components/library/lineup/lineup-details-embed.component';
import { PublicationFieldGuard } from 'app/guards/publicationField.guard';
import { ChannelDetailsAddElementComponent } from 'app/components/library/channel/channel-details-add-element.component';

const libraryModuleRoutes: Routes = [
	{
		path: 'library',
		component: LibraryComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: 'mediaclips', component: MediaclipListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'mediaclip/:id', redirectTo: 'mediaclip/:id/metadata', pathMatch: 'full' },
			{ path: 'mediaclip/:id/:tab', component: MediaclipDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'interactivity', redirectTo: 'interactivity/:id', pathMatch: 'full' },
			{
				path: 'interactivity/:id',
				data: {
					permissions: ['interactivity'],
					class: 'has-sidebar has-buttonbar'
				},
				canActivate: [PermissionGuard],
				component: InteractivityTimelineDetailsComponent,
				canDeactivate: [NavigateAwayGuard]
			},
			{ path: 'upload-transcode', redirectTo: 'upload-transcode/upload' },
			{ path: 'upload-transcode/:tab', component: UploadTranscodeComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'projects', component: LibraryProjectListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'project/:id', redirectTo: 'project/:id/metadata', pathMatch: 'full' },
			{ path: 'project/:id/:tab', component: LibraryProjectDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'placements', component: PlacementListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'placement/:id', redirectTo: 'placement/:id/metadata', pathMatch: 'full' },
			{ path: 'placement/:id/:tab', component: PlacementDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{
				path: 'lineups', component: LineupListComponent,
				data: {
					publicationField: 'lineups',
					class: 'has-sidebar has-header'
				},
				canActivate: [PublicationFieldGuard]
			},
			{ path: 'lineup/:id', redirectTo: 'lineup/:id/general', pathMatch: 'full' },
			{
				path: 'lineup/:id/:tab', component: LineupDetailsComponent, canDeactivate: [NavigateAwayGuard],
				data: {
					publicationField: 'lineups',
					class: 'has-sidebar has-header'
				},
				canActivate: [PublicationFieldGuard]
			},
			{ path: 'social', component: SocialListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'social/:id', redirectTo: 'social/:id/general', pathMatch: 'full' },
			{ path: 'social/:id/:tab', component: SocialDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'social/facebook/:id', redirectTo: 'social/facebook/:id/settings', pathMatch: 'full' },
			{ path: 'social/facebook/:id/:tab', component: SocialDetailsFacebookComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'social/instagram/:id', redirectTo: 'social/instagram/:id/settings', pathMatch: 'full' },
			{ path: 'social/instagram/:id/:tab', component: SocialDetailsInstagramComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'playouts', component: PlayoutListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'playout/:id', redirectTo: 'playout/:id/appearance' },
			{ path: 'playout/:id/:tab', component: PlayoutDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'playlists', component: PlaylistListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'playlist/:id', redirectTo: 'playlist/:id/general' },
			{ path: 'playlist/:id/:tab', component: PlaylistDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{
				path: 'channels', component: ChannelListComponent,
				data: {
					publicationField: 'channels',
					class: 'has-sidebar has-header'
				},
				canActivate: [PublicationFieldGuard]
			},
			{ path: 'channel/:id', redirectTo: 'channel/:id/general', pathMatch: 'full' },
			{
				path: 'channel/:id/:tab', component: ChannelDetailsComponent,
				data: {
					publicationField: 'channels'
				},
				canActivate: [PublicationFieldGuard],
				canDeactivate: [NavigateAwayGuard]
			},
			{ path: 'datafeeds', component: DatafeedListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'datafeed/:id', redirectTo: 'datafeed/:id/metadata' },
			{ path: 'datafeed/:id/:tab', component: DatafeedDetailsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'templates', component: TemplatesListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'template/:id', component: TemplateRedirectComponent },
			{ path: 'trash', component: TrashListComponent, data: { class: 'has-sidebar has-header' } },
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(libraryModuleRoutes),
		CommonModule,
		SharedModule,
		PipesModule,
		FormsModule,
		BbTableModule
	],
	declarations: [
		EmbedPreviewComponent,
		LibraryProjectListComponent,
		LibraryProjectDetailsComponent,
		LibraryProjectDetailsFlowchartComponent,
		LibraryProjectDetailsMetadataComponent,
		LibraryProjectDetailsAnalysisComponent,
		LibraryProjectDetailsThumbnailComponent,
		LibraryProjectDetailsEmbedComponent,
		LibraryProjectDetailsReactComponent,
		PlacementListComponent,
		PlacementDetailsComponent,
		PlacementDetailsMetadataComponent,
		LineupListComponent,
		LineupDetailsComponent,
		LineupDetailsCyclesComponent,
		LineupDetailsGeneralComponent,
		LineupDetailsConfigurationComponent,
		LineupDetailsEmbedComponent,
		ProjectKpiMakerComponent,
		SocialListComponent,
		SocialDetailsFacebookComponent,
		SocialDetailsInstagramComponent,
		SocialDetailsComponent,
		SocialDetailsYoutubeComponent,
		SocialDetailsAutomatedSyncingComponent,
		SocialFacebookSyncedComponent,
		SocialChannelCardComponent,
		PlayoutListComponent,
		PlayoutDetailsComponent,
		PlayoutDetailsAppearanceComponent,
		PlayoutDetailsControlbarComponent,
		PlayoutDetailsSharingComponent,
		PlayoutDetailsStartEndscreenComponent,
		PlayoutDetailsBehaviourComponent,
		PlayoutDetailsAdvertisingComponent,
		PlayoutDetailsMiscellaneousComponent,
		PlayoutDetailsViewpageComponent,
		PlaylistSelectComponent,
		MediaclipListComponent,
		MediaclipDetailsComponent,
		MediaclipDetailsMetadataComponent,
		MediaclipDetailsChaptersComponent,
		MediaclipDetailsEmbedComponent,
		MediaclipDetailsLanguagesComponent,
		MediaclipDetailsLiveComponent,
		MediaclipDetailsRestreamingComponent,
		SubtitleQuickEditComponent,
		AudiotrackQuickEditComponent,
		AssetQuickeditComponent,
		RestreamQuickeditComponent,
		ChannelListComponent,
		ChannelDetailsComponent,
		ChannelDetailsGeneralComponent,
		ChannelDetailsDetailpageComponent,
		ChannelDetailsElementsComponent,
		ChannelDetailsEmbedComponent,
		ChannelDetailsAddElementComponent,
		MediaclipDetailsThumbnailComponent,
		MediaclipDetailsResourcesComponent,
		MediaclipDetailsExportComponent,
		MediaclipDetailsReactComponent,
		DatafeedListComponent,
		DatafeedDetailsComponent,
		DatafeedDetailsMetadataComponent,
		TemplatesListComponent,
		TemplateRedirectComponent,
		TrashListComponent,
		PlaylistListComponent,
		PlaylistDetailsComponent,
		PlaylistDetailsGeneralComponent,
		PlaylistDetailsRssComponent,
		PlaylistDetailsEmbedComponent,
		LibraryComponent,
		UploadTranscodeComponent,
		UploadTranscodeUploadComponent,
		UploadTranscodeBbLivestreamComponent,
		UploadTranscodePublicationImportComponent,
		UploadTranscodeThirdPartyLivestreamComponent,
		UploadTranscodeLiveComponent,
		BbFitmodeComponent,
	],
	exports: [
		EmbedPreviewComponent,
		LibraryProjectListComponent,
		LibraryProjectDetailsComponent,
		LibraryProjectDetailsFlowchartComponent,
		LibraryProjectDetailsMetadataComponent,
		LibraryProjectDetailsAnalysisComponent,
		LibraryProjectDetailsThumbnailComponent,
		LibraryProjectDetailsEmbedComponent,
		LibraryProjectDetailsReactComponent,
		PlacementListComponent,
		PlacementDetailsComponent,
		PlacementDetailsMetadataComponent,
		LineupListComponent,
		LineupDetailsComponent,
		LineupDetailsCyclesComponent,
		LineupDetailsGeneralComponent,
		LineupDetailsConfigurationComponent,
		LineupDetailsEmbedComponent,
		ProjectKpiMakerComponent,
		SocialListComponent,
		SocialDetailsFacebookComponent,
		SocialDetailsInstagramComponent,
		SocialDetailsComponent,
		SocialDetailsYoutubeComponent,
		SocialDetailsAutomatedSyncingComponent,
		SocialFacebookSyncedComponent,
		SocialChannelCardComponent,
		PlayoutListComponent,
		PlayoutDetailsComponent,
		PlayoutDetailsAppearanceComponent,
		PlayoutDetailsControlbarComponent,
		PlayoutDetailsSharingComponent,
		PlayoutDetailsStartEndscreenComponent,
		PlayoutDetailsMiscellaneousComponent,
		PlayoutDetailsViewpageComponent,
		PlayoutDetailsBehaviourComponent,
		MediaclipListComponent,
		MediaclipDetailsComponent,
		MediaclipDetailsMetadataComponent,
		MediaclipDetailsChaptersComponent,
		MediaclipDetailsEmbedComponent,
		MediaclipDetailsLanguagesComponent,
		MediaclipDetailsLiveComponent,
		MediaclipDetailsRestreamingComponent,
		MediaclipDetailsResourcesComponent,
		MediaclipDetailsExportComponent,
		SubtitleQuickEditComponent,
		AudiotrackQuickEditComponent,
		AssetQuickeditComponent,
		ChannelListComponent,
		ChannelDetailsComponent,
		ChannelDetailsGeneralComponent,
		ChannelDetailsDetailpageComponent,
		ChannelDetailsElementsComponent,
		ChannelDetailsEmbedComponent,
		ChannelDetailsAddElementComponent,
		RestreamQuickeditComponent,
		MediaclipDetailsThumbnailComponent,
		DatafeedListComponent,
		DatafeedDetailsComponent,
		DatafeedDetailsMetadataComponent,
		TemplatesListComponent,
		TemplateRedirectComponent,
		TrashListComponent,
		PlaylistListComponent,
		PlaylistDetailsComponent,
		PlaylistDetailsGeneralComponent,
		PlaylistDetailsRssComponent,
		PlaylistDetailsEmbedComponent,
		LibraryComponent,
		BbLibraryMenuComponent,
		PlaylistSelectComponent,
		UploadTranscodeComponent,
		UploadTranscodeUploadComponent,
		UploadTranscodeBbLivestreamComponent,
		UploadTranscodePublicationImportComponent,
		UploadTranscodeThirdPartyLivestreamComponent,
		UploadTranscodeLiveComponent,
		BbFitmodeComponent
	],
	providers: [
		FlowchartService,
		SubtitleService,
		BbLibraryMenuComponent
	]
})
export class LibraryModule {

}
